import { useLocation } from 'react-router-dom';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { Separator } from '@/components/ui/separator';
import { NotificationBell } from './notification-bell';

interface HeaderProps {
  title?: string;
}

export default function Header({ title }: HeaderProps) {
  const location = useLocation();
  const path = location.pathname;
  
  const getPageTitle = () => {
    if (title) return title;
    
    const routes: Record<string, string> = {
      '/home': 'Dashboard',
      '/review': 'Review Requests',
      '/it-tasks': 'IT Tasks',
      '/data-tasks': 'Data Tasks',
      '/activation': 'Activation',
    };
    
    // Check exact match
    if (routes[path]) {
      return routes[path];
    }
    
    // Check if it's a sub-route
    for (const [route, name] of Object.entries(routes)) {
      if (path.startsWith(route + '/')) {
        return name;
      }
    }
    
    return 'Dashboard';
  };

  return (
    <header className="sticky top-0 z-10 flex h-16 shrink-0 items-center gap-4 border-b bg-white/95 backdrop-blur-md shadow-sm px-4">
      <SidebarTrigger className="-ml-1" />
      <Separator orientation="vertical" className="h-6" />
      <h1 className="text-lg font-semibold text-gray-900 flex-1">{getPageTitle()}</h1>
      <NotificationBell />
    </header>
  );
}
